import React from 'react';
import parse from 'html-react-parser';
import { connect } from 'react-redux';
import { Segment, Header, Icon, Grid, Card, Breadcrumb, Image, Modal, Button, Label, Message, TextArea, GridColumn } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import _ from 'lodash';
import { orderBy as _orderBy } from 'lodash';
import './PlaceBidContainerNew.less';
import moment from 'moment';
import { getSingleBuyerRequestDetails, getSbrBidsHistory, placeBid, growWithDealgrace } from '../../services/Project';
import TimeCountDown from '../../components/TimeCountDown/TimeCountDown';
import BidHistory from '../../components/BidHistory/BidHistory';
import BidHistoryNew from '../../components/BidHistoryNew/BidHistoryNew';
import RequestInfo from '../../components/RequestInfo/RequestInfo';
import RequestInfoNew from '../../components/RequestInfoNew/RequestInfoNew';
import PhotoCarousel from '../../components/PhotoCarousel/PhotoCarousel';
import PhotoCarouselNew from '../../components/PhotoCarouselNew/PhotoCarouselNew';
import { showNotificationMessage } from '../../store/actions/reactNotification'
import { SUCCESS, ERROR } from '../../constants/NotificationType';
import { priceRegex } from '../../constants/regex';
import { priceDisplay } from '../../helpers/price';
import { withRouter } from 'react-router';
import "react-datetime/css/react-datetime.css";
import DatetimePicker from '../../components/Controls/DatetimePicker/DatetimePicker';
import Formsy, { addValidationRule } from 'formsy-react';
import DGTextbox from '../../components/FormControls/Textbox/DGTextbox';
import DGDateTimePicker from '../../components/FormControls/DateTimePicker/DGDateTimePicker';
import { isValidToBid, newLeadAlert, requestMoreInfo } from '../../services/Seller';
import DGTextarea from '../../components/FormControls/Textarea/DGTextarea';
import profile_banner from "../../assets/images/newui/profile-banner.svg"
import { width } from 'dom-helpers';
import confirmation_tick from '../../assets/images/newui/confirmation-tick.png'
import { IN_TRIAL } from '../../constants/SellerSubscriptionStatus';
import { format } from 'react-phone-input-auto-format';
import { isValidCellNumber, isValidEmail } from '../../helpers/validation';
import { getActiveSubscriptions, getPlans } from '../../services/subscription';
import { getRequestDetails } from '../../services/Services';


addValidationRule('isValidDate', function (values, value, array) {

  if (value && typeof value == 'string') {
    return false;
  }
  return true;
});

addValidationRule('isValidBid', function (values, value, compareWithValue) {
  const bidPrice = parseFloat(value);
  if (!bidPrice) {
    return 'Please enter a quote price.';
  } else if (isNaN(bidPrice)) {
    return 'Please enter a valid quote price.'
  }
  return true;
})
class PlaceBidContainerNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      details: { bid: {}, service: {}, sbr: {}, images: [], seller: {}, category: {} },
      openedImageIndex: -1,
      bidsHistory: [],
      bidPrice: 0,
      sellerAvailability: null,
      errorMessage: '',
      isErrorMessageType: true,
      errorMessageClient: '',
      contactUsDetails: {},
      isMoreInfoModalOpen: false,
      growWithDealgraceNotificationModal: false,
      sellerInfoRequestMessage: '',
      isContactDetailsModalOpen: false,
      isContactDetailsFormValid: true,
      contactName:'',
      phone: '',
      email: '',
      alertButtonType: ""
    }
    this.sbrId = 0;
  }

  async refreshDetails() {
    const details = this.props.isUnAuthorized ? await getRequestDetails(this.sbrId) : await getSingleBuyerRequestDetails(this.sbrId);
    let bidsHistory;
    if (details && details.data && details.data.bid && details.data.bid /*&& details.data.bid.sellerBid*/) {
      bidsHistory = await getSbrBidsHistory(this.sbrId);
    }
    await this.setState({
      details: details && details.data || { bid: {}, service: {}, sbr: {}, images: [], seller: {}, category: {} },
      bidsHistory: bidsHistory && bidsHistory.data || []
    });
  }
  async componentDidMount() {
    this.sbrId = this.props.requestId || this.props.match.params.requestId;
    if (this.props.isUnAuthorized) {
      await this.refreshDetails();
      return;
    }
    const validBidResponse = await isValidToBid(this.sbrId);
    if (validBidResponse.resStatus == 200) {
      const data = validBidResponse.data;
      if (data === false) {
        this.props.history.push(`/`);
      }
    }
    await this.refreshDetails();
  }

  validateBidPrice = (bidPrice) => {
    if (!bidPrice) {
      this.setState({ errorMessageClient: "Please enter a quote price." })
      return false;
    }
    else if (isNaN(bidPrice)) {
      this.setState({ errorMessageClient: "Please enter a valid quote price." })
      return false;
    }
    this.setState({ errorMessageClient: "" })
    return true;
  }

  save = () => {
    const { bidPrice, sellerAvailability } = this.state;
    this.setState({ errorMessage: '', isErrorMessageType: true });

    if (!this.validateBidPrice(bidPrice)) {
      return;
    }
    if(this.props.isUnAuthorized)
    {
      this.setState({isContactDetailsModalOpen: true,
        alertButtonType: "Submit Quote"
      });
    }else
    {
      placeBid(this.sbrId, { bidPrice, sellerAvailability: sellerAvailability ? sellerAvailability.format('YYYY-MM-DD HH:mm:ss') : null })
      .then((response) => {
        if (response.resStatus == 200) {
          this.props.showNotificationMessage(SUCCESS, 'Quote placed successfully.');
          //this.props.history.push('/home/dashboard');

          this.redirectToCheckoutPage();

          if (this.props.afterBidPlaced) {
            this.props.afterBidPlaced();
          } else {
            // redirect to open request page.
            this.setState({ errorMessage: `Quote of ${priceDisplay(bidPrice)} placed successfully.`, isErrorMessageType: false, bidPrice: "" })
            setTimeout(() => {
              this.props.history.push('/');
            }, 1500);
          }
        } else if (response.resStatus >= 400) {
          this.props.showNotificationMessage(ERROR, response.message || 'Quote placing failed.');
          this.setState({ errorMessage: response.message, isErrorMessageType: true })
        }
      })
      .catch((e) => {
        console.log(e);
        this.props.showNotificationMessage(ERROR, 'Quote placing failed.');
      });
  }
  }

  handleChange = (e, { name, value }) => {
    this.setState({ bidPrice: value, errorMessage: '', isErrorMessageType: true, errorMessageClient: "" });
    this.validateBidPrice(value);
  }

  onSellerAvailabilityChange = (dateTime) => {
    this.setState({ sellerAvailability: dateTime });
  }

  onRequetInfoSubmit = async () => {
    await requestMoreInfo({
      ...this.state.contactUsDetails,
      Question: this.state.sellerInfoRequestMessage,
      subject: 'More Info Request',
    });
    this.setState({ isMoreInfoModalOpen: false }, () => {
      this.redirectToCheckoutPage();
    })
  }

  onMoreInfoClick = (e) => {
    e.preventDefault();
    if (this.props.isUnAuthorized) {
      this.setState({
        contactUsDetails: {
          ServiceName: this.state.details.service.name,
          serviceID: this.state.details.service.serviceID,
          RequestID: this.sbrId,
        },
        isContactDetailsModalOpen: true,
        alertButtonType: "Have Questions"
      })
    }else
    {
      this.setState({
      contactUsDetails: {
        SellerPhone: this.props.currentUser.Seller.cellPhone,
        SellerName: this.props.currentUser.Seller.name,
        SellerEmail: this.props.currentUser.Seller.email,
        ServiceName: this.state.details.service.name,
        serviceID: this.state.details.service.serviceID,
        RequestID: this.sbrId,
      },
      isMoreInfoModalOpen: true
      })
    } 
  }

  growWithDealgraceClick = async (e) => {
    if (this.props.isUnAuthorized) {
      this.setState({
        isContactDetailsModalOpen: true,
        alertButtonType: "Grow With " + (this.state.details.category && this.state.details.category.brandName ? this.state.details.category.brandName : 'DEALGRACE')
      })
      // this.navigateToCheckout(e);
    }else
    {
      this.redirectToCheckoutPage();
    }
    // let res = await growWithDealgrace(this.sbrId);
    // if (res.status == "success") {
    //   if (this.state.details.category.marketingRedirectURL) {
    //     window.open(this.state.details.category.marketingRedirectURL, "_self");
    //   }
    //   else {
    //     this.redirectToCheckoutPage();
    //     // this.props.history.push(`/add-subscription?categoryId=${this.state.details.category.categoryID}`)
    //   }
    // }
  }

  highlightText = (text, textToEmphasize) => {
    var result = text;

    if (textToEmphasize && !_.isEmpty(textToEmphasize)) {
      const textCopy = result.toLowerCase();
      textToEmphasize = textToEmphasize.toLowerCase();

      const index = textCopy.indexOf(textToEmphasize);

      if (index >= 0) {
        const textToEmphasizeExtract = result.substring(index, (index + textToEmphasize.length));
        result = text.replace(textToEmphasizeExtract, `<span className="highlightedText">${textToEmphasizeExtract}</span>`);
      }
    }
    return result;
  }

  getRightPanelColumn = (columnWidth) => {
    return (
      <Grid.Column onClick={(e) => this.growWithDealgraceClick(e)} width={columnWidth} style={{ paddingLeft: "0px" }}>
        <Grid.Row className={"right-panel-heading-row"} columns={1} style={{ paddingTop: window.innerWidth < 1024 ? "20px" : "0px" }}>
          <Grid.Column width="16">
            <div className={"heading-container"}>
              {this.state.details.category.freeTrialHeading ? parse(this.highlightText(this.state.details.category.freeTrialHeading, this.state.details.category.freeTrialHeadingHighlightedText)) : ""}
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className={"right-panel-button-row"} columns={1} style={{ paddingTop: "0px" }}>
          <Grid.Column width="16">
          <div className={"submit-btn-container centre"}>      
            <Button className="button-submit-green" type={"button"}>
                GROW WITH <span style={{textTransform: 'uppercase'}}>
                  {this.state.details.category && this.state.details.category.brandName ? this.state.details.category.brandName : 'DEALGRACE'}</span> 
            </Button>
          </div>
            {/* <div className={"button-container"}>
              <Button className={"button"} type={"button"}>
                GROW WITH <span style={{textTransform: 'uppercase'}}>{this.state.details.category && this.state.details.category.brandName ? this.state.details.category.brandName : 'DEALGRACE'}</span> 
              </Button>
            </div> */}
          </Grid.Column>
        </Grid.Row>
        {
          this.getFreeTrialMarketingImage(this.state.details.category) ?
            <Grid.Row className={"right-panel-image-row"} columns={1} style={{ paddingTop: "0px" }}>
              <Grid.Column width="16">
                <div className={"image-container"}>
                  <div className={"profile-banner-image-container"}>
                    <img className={"profile-banner-image"} src={this.getFreeTrialMarketingImage(this.state.details.category) ? this.getFreeTrialMarketingImage(this.state.details.category) : ""}>
                    </img>
                  </div>
                  {/* <div className={"background-circle"}>
                                
                              </div> */}
                </div>
              </Grid.Column>
            </Grid.Row>
            :
            <div style={{ marginBottom: '30px' }}>

            </div>
        }
      </Grid.Column>
    )
  }

  getFreeTrialMarketingImage = (category) => {
    if (category.freeTrialcategoryImage) {
      return category.freeTrialcategoryImage.freeTrial.URL
    } else {
      return false;
    }
  }

  handleBidPriceKeyDown = (e) => {
    if (e.key === '.') {
      e.preventDefault()
    }
  }

  handleClick = async (e) => {
    if (this.props.isUnAuthorized) {
      e.preventDefault();
      this.setState({ isContactDetailsModalOpen: true , isMoreInfoModalOpen:false })
      // this.navigateToCheckout();
    }
  }

  handlePhoneChange = (e, { value }) => {
    this.setState({ phone: format(value) });
  }

  onPhoneKeyDown = (evt) => {

    if (evt.key != 'Backspace' && evt.key != 'Delete' && evt.key != 'Tab') {
      var patt = new RegExp(/^[0-9\b]+$/);
      var res = patt.test(evt.key);
      if (!res)
        evt.preventDefault()
    }
  }

  leadAlert = async () => {
    let alertDataMessage = `[${this.state.alertButtonType}] requestID: ${this.state.details.sbr.singleBuyerRequestID}, phone: ${`<tel:${this.state.phone.replace('-', '').replace('(', '').replace(')', '')}>`}, email: ${this.state.email}, contactName: ${this.state.contactName}, category: ${this.state.details.category.categoryName}`;
    const { bidPrice, sellerAvailability } = this.state;
    debugger
    if(bidPrice && this.state.alertButtonType == "Submit Quote")
    {
      alertDataMessage += `, bidPrice: ${bidPrice}`

      if(sellerAvailability)
      {
        alertDataMessage += `, availability: ${sellerAvailability}`
      }
    }

    await newLeadAlert({alertDataMessage});
    this.setState({isContactDetailsModalOpen : false, growWithDealgraceNotificationModal : true , contactName: "" , phone: "", email: ""});
  }

  onContactDetailsSubmit = async () => {
    if (isValidCellNumber([], this.state.phone) && isValidEmail([], this.state.email) && this.state.contactName.length > 0) {
      this.setState({ isContactDetailsFormValid: true })

      this.leadAlert();
      // const plans = await getPlans(this.state.details.category.categoryID);
      // if (plans?.data?.length) {
      //   const premiumPlan = plans.data.find(p => p.plan.planType == "Premium");

      //   if (premiumPlan) {
      //     this.props.history.push(`/business/checkout/${premiumPlan.plan.planID}`)
      //   }
      //   else {
      //     this.props.history.push(`/business/checkout/${plans.data[0].plan.planID}`)
      //   }
      // } else {
      //   this.props.history.push('/business/signup')
      // }
    } else {
      this.setState({ isContactDetailsFormValid: false })
    }
  }

  navigateToCheckout = async (e) => {
    if (this.props.isUnAuthorized) {
      const plans = await getPlans(this.state.details.category.categoryID);
      if (plans?.data?.length) {
        const premiumPlan = plans.data.find(p => p.plan.planType == "Premium");

        if (premiumPlan) {
          this.props.history.push(`/business/checkout/${premiumPlan.plan.planID}`)
        }
        else {
          this.props.history.push(`/business/checkout/${plans.data[0].plan.planID}`)
        }
      } else {
        this.props.history.push('/business/signup')
      }
    } else {
      this.setState({ isContactDetailsFormValid: false })
    }
  }

  redirectToCheckoutPage = async () => {
    try {
      if (this.state?.details?.seller?.subStatus == IN_TRIAL) {

        const plans = await getPlans(this.state.details.category.categoryID);

        const activeSubs = await getActiveSubscriptions();

        if (activeSubs?.data?.length) {
          activeSubs.data.forEach(activeSub => {
            plans.data = plans.data.filter((p) => {
              return p.plan.planID != activeSub.planID;
            })
          });
        }

        if (plans?.data?.length) {
          const premiumPlan = plans.data.find(p => p.plan.planType == "Premium");

          if (premiumPlan) {
            this.props.history.push(`/add-subscription/${premiumPlan.plan.planID}`)
          }
          else {
            this.props.history.push(`/add-subscription/${plans.data[0].plan.planID}`)
          }
        } else {
          this.props.history.push('/add-subscription')
        }
      } else {
        this.props.history.push('/add-subscription')
      }
    } catch (error) {
      this.props.history.push('/add-subscription')
    }
  }

  render() {
    const { details, bidsHistory } = this.state;
    const { bid, service, sbr, images, seller } = details;
    const sellerInTrial = this.props.isUnAuthorized ? true : seller ? seller?.subStatus == IN_TRIAL ? true : false : false;
    let postProcessingaAvailable = this.props.isUnAuthorized || (sbr.postProcessing && sbr.postProcessing.length > 0) ? true : false;

    return (
      <div 
        // onClick={this.handleClick} 
        className="place-bid-container animated fadeInRight">
        {/*<Segment.Group>
          <Segment size="massive" className="no-radius">
            <Header as="h1">
              <Header.Content>
                Place Bid
              </Header.Content>
            </Header>
          </Segment>
          {/*<Segment size="mini" className="no-radius breadcrumb">
            <Breadcrumb>
              <HomeBCItem history={this.props.history} />
              <Breadcrumb.Divider />
              <Breadcrumb.Section active>Place Bid</Breadcrumb.Section>
            </Breadcrumb>
          </Segment>
        </Segment.Group> */}
        <Grid >
          <Grid.Row className={"top-heading-row"}>
            <Grid.Column className={"top-heading-col"}>
              <Grid.Row className={"service-name-row"}>
                <GridColumn className={"service-name-column"}>
                  <div className={"service-name-container"}>
                    <div className={"service-name"}>
                      {service?.name}
                    </div>
                  </div>
                </GridColumn>
              </Grid.Row>
              <Grid.Row className={"header-row"}>
                <GridColumn className={"header-column"}>
                  <div className={"header-container"}>
                    <div className={"header"}>
                      {service.placeBidPageHeading && service.placeBidPageHeading.length > 0 ? service.placeBidPageHeading
                        : ""}
                      {/* Quote a Ready-to-Book Customer from Dealgrace */}
                    </div>
                  </div>
                </GridColumn>
                {this.state.errorMessage.length > 0 ?
                  <GridColumn className={"header-column"}>
                    <div className={"error-msg-container"}>
                      <Message color={this.state.isErrorMessageType ? "red" : "green"} error className={"error-msg"} visible={this.state.errorMessage.length > 0} >
                        <Message.Content>
                          <div className={"icon"}>
                            <svg id="_Left_Icon" data-name="🔶 Left Icon" xmlns="http://www.w3.org/2000/svg" width="18.333" height="18.333" viewBox="0 0 18.333 18.333">
                              <path id="_Icon_Color" data-name="🔹 Icon Color" d="M9.167,18.333A9.17,9.17,0,0,1,2.682,2.682,9.17,9.17,0,0,1,15.651,15.651,9.108,9.108,0,0,1,9.167,18.333Zm0-7.874h0l2.374,2.374,1.293-1.293L10.459,9.167l2.374-2.374L11.541,5.5,9.167,7.874,6.792,5.5,5.5,6.792,7.874,9.167,5.5,11.541l1.292,1.293L9.166,10.46Z" fill={this.state.isErrorMessageType ? "#fa3434" : "#60C778"} />
                            </svg>
                          </div>
                          <div className={"message"}>
                            {this.state.errorMessage}
                          </div>
                        </Message.Content>
                      </Message>
                    </div>
                  </GridColumn> : ""
                }
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row className={"content-panel-row"}>
            <Grid.Column>
              <Form onValidSubmit={this.save} ref="form">
                <Grid style={{ backgroundColor: "white" }}>
                  <Grid.Row 
                  // onClick={this.handleClick} 
                  style={{ paddingBottom: '0px' }}>
                    <Grid.Column computer={16} mobile={16}>
                      <div className="place-bid-segment-">
                        <Grid className={`place-bid-form-grid ${postProcessingaAvailable ? "with-post-processing" : ""}`}
                        // style={{ marginBottom: '0px' }}
                        >
                          {/* <Grid.Row className={"place-bid-form-row-"}>
                            <Grid.Column computer={16} mobile={16}>
                              <Message error className={"error-msg-container"} content={this.state.errorMessage} visible={this.state.errorMessage.length > 0} />
                            </Grid.Column>
                          </Grid.Row> */}

                          {
                            postProcessingaAvailable ?
                              <Grid.Row className={"place-bid-post-process-row"}>
                                <Grid.Column computer={16} mobile={16} className={"place-bid-post-process-column"}>
                                  <div className={"post-processing-text"}>
                                    {sbr.postProcessing + " " + sbr.quickInfo}
                                  </div>
                                </Grid.Column>
                              </Grid.Row>
                              : ""
                          }

                          <Grid.Row className={"place-bid-form-row"}>
                            <Grid.Column computer={16} mobile={16} className={"place-bid-form-column"}>
                              <div>
                                {/* <div className={"error-msg-container"}>
                                  <Message error className={"error-msg"} content={this.state.errorMessage} visible={this.state.errorMessage.length > 0} />
                                </div> */}
                                <div className={"outer-wrapper"}>
                                  <div className={"place-bid-form-container"}>

                                    <div className={"left-arrow-container"}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="8.627" height="17.255" viewBox="0 0 8.627 17.255">
                                        <path id="Path_41861" data-name="Path 41861" d="M-5717.5,10588.752l8.627,8.627-8.627,8.628Z" transform="translate(5717.5 -10588.752)" fill="#7ac943" />
                                      </svg>
                                    </div>
                                    <div className={"bid-price-container"}>
                                      <DGTextbox
                                        autoComplete="off"
                                        name="minPrice"
                                        placeholder='$'
                                        value={this.state.bidPrice}
                                        onChange={this.handleChange}
                                        onKeyPress={(e) => { this.handleBidPriceKeyDown(e) }}
                                        label="Your Quote"
                                        validations={{
                                        }}
                                      />

                                      {
                                        window.innerWidth < 1024 && this.state.errorMessageClient.length > 0 &&
                                        <div className={"client-error-message-container"}>
                                          <div className={"top-arrow"}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="7.092" height="3.546" viewBox="0 0 7.092 3.546">
                                              <path id="Path_41865" data-name="Path 41865" d="M-5717.5,10588.752l3.546,3.546-3.546,3.546Z" transform="translate(-10588.752 -5713.954) rotate(-90)" fill="#feeaea" />
                                            </svg>
                                          </div>
                                          <div>
                                            {this.state.errorMessageClient}
                                          </div>
                                        </div>
                                      }

                                    </div>
                                    <div className={"availability-container"}>
                                      <div className={"availability"}>
                                        <DGDateTimePicker
                                          name="selleravailability"
                                          label="Your Earliest Availability"
                                          placeholder='Optional'
                                          validations={{
                                            isValidDate: true
                                          }}
                                          validationErrors={{
                                            isValidDate: 'Invalid value'
                                          }}
                                          onChange={this.onSellerAvailabilityChange}
                                        />
                                      </div>
                                      <div className={"icon-container"}>
                                        <svg className={"icon"} xmlns="http://www.w3.org/2000/svg" width="35.244" height="36.249" viewBox="0 0 35.244 36.249">
                                          <g id="Group_15627" data-name="Group 15627" transform="translate(0)">
                                            <path id="Path_28780" data-name="Path 28780" d="M4941.5-645.673v-2.9h1.979v2.862h15.615v-2.843h1.971v2.887c1.055,0,2.03-.013,3,0a4.805,4.805,0,0,1,4.574,3.353,6.863,6.863,0,0,1,.261,1.966c.018,7.585-.031,15.17.032,22.755a5.077,5.077,0,0,1-5.318,5.267c-8.227-.03-16.454-.006-24.682-.012a4.863,4.863,0,0,1-5.1-3.755,6.387,6.387,0,0,1-.135-1.541q-.012-11.489,0-22.977a4.837,4.837,0,0,1,5.087-5.058C4939.669-645.676,4940.551-645.673,4941.5-645.673Zm25.457,9.856h-31.3v.79q0,8.707,0,17.415c0,2.176,1.106,3.289,3.27,3.29q12.375,0,24.751,0a2.936,2.936,0,0,0,3.281-3.292q0-8.707,0-17.415Zm-.008-2.033c0-1.071.023-2.058,0-3.044a2.715,2.715,0,0,0-2.218-2.685,33.413,33.413,0,0,0-3.607-.2v1.969h-2.042v-1.862h-15.616v1.873h-1.985v-1.92c-1.1,0-2.11-.062-3.111.015a2.853,2.853,0,0,0-2.671,2.371c-.1,1.143-.021,2.3-.021,3.487Z" transform="translate(-4933.693 648.578)" fill="#fff" />
                                            <path id="Path_28781" data-name="Path 28781" d="M5029.795-541.824c-.641,0-1.283.017-1.923-.005a1.877,1.877,0,0,1-1.916-1.852c-.048-1.355-.04-2.713,0-4.068a1.775,1.775,0,0,1,1.616-1.819,36.083,36.083,0,0,1,4.571,0,1.8,1.8,0,0,1,1.637,1.881c.03,1.306.034,2.615,0,3.921a1.912,1.912,0,0,1-1.985,1.945C5031.128-541.809,5030.461-541.823,5029.795-541.824Zm-1.885-1.983h3.933c0-1.192.007-2.342-.012-3.492,0-.127-.16-.361-.248-.362-1.215-.024-2.432-.016-3.672-.016Z" transform="translate(-5012.25 564.31)" fill="#fff" />
                                            <path id="Path_28782" data-name="Path 28782" d="M5095.879-541.826c-.642,0-1.283.017-1.923,0a1.887,1.887,0,0,1-1.916-1.857c-.037-1.355-.032-2.712,0-4.068a1.788,1.788,0,0,1,1.618-1.818,35.849,35.849,0,0,1,4.569,0,1.8,1.8,0,0,1,1.633,1.882c.024,1.306.028,2.614,0,3.92a1.907,1.907,0,0,1-1.983,1.942C5097.21-541.81,5096.545-541.825,5095.879-541.826Zm2-5.82h-3.866v3.829h3.866Z" transform="translate(-5068.543 564.311)" fill="#fff" />
                                            <path id="Path_28783" data-name="Path 28783" d="M5029.806-475.792c-.64,0-1.281.015-1.921,0a1.894,1.894,0,0,1-1.938-1.911q-.051-1.995,0-3.992a1.863,1.863,0,0,1,1.821-1.873c1.378-.051,2.761-.048,4.139,0a1.88,1.88,0,0,1,1.864,1.912q.053,1.958,0,3.918a1.9,1.9,0,0,1-1.975,1.95C5031.138-475.778,5030.472-475.791,5029.806-475.792Zm2-5.773h-3.881v3.789h3.881Z" transform="translate(-5012.25 508.064)" fill="#fff" />
                                            <path id="Path_28784" data-name="Path 28784" d="M5095.881-475.776c-.642,0-1.285.015-1.927,0a1.877,1.877,0,0,1-1.923-1.851q-.059-2.036,0-4.075a1.839,1.839,0,0,1,1.776-1.838c1.406-.058,2.817-.059,4.223-.009a1.864,1.864,0,0,1,1.816,1.885c.033,1.333.036,2.668,0,4a1.89,1.89,0,0,1-1.962,1.889C5097.215-475.763,5096.547-475.776,5095.881-475.776Zm1.979-1.969v-3.8H5094v3.8Z" transform="translate(-5068.533 508.048)" fill="#fff" />
                                            <path id="Path_28785" data-name="Path 28785" d="M4963.792-475.777c-.642,0-1.285.015-1.928,0a1.874,1.874,0,0,1-1.922-1.848c-.043-1.357-.038-2.718,0-4.076a1.851,1.851,0,0,1,1.778-1.844c1.4-.056,2.815-.055,4.221,0a1.848,1.848,0,0,1,1.82,1.879c.045,1.333.047,2.669,0,4a1.885,1.885,0,0,1-1.963,1.891C4965.126-475.763,4964.459-475.777,4963.792-475.777Zm-1.889-1.992h3.879v-3.773H4961.9Z" transform="translate(-4956.025 508.049)" fill="#fff" />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                    <div className={"submit-btn-container"}>
                                      <Button className="button-submit-green" type="submit">Submit Quote</Button>
                                    </div>
                                  </div>
                                </div>

                                {
                                  window.innerWidth >= 1024 && this.state.errorMessageClient.length > 0 &&
                                  <div className={"client-error-msg-container"}>
                                    {this.state.errorMessageClient}
                                  </div>
                                }
                              </div>
                            </Grid.Column>
                            {/* <div style={{display:"flex"}}>
                                <Message error className={"error-msg-container"} content={this.state.errorMessage} visible={this.state.errorMessage.length > 0} />
                                </div> */}
                            {/* <Grid.Column computer={8} mobile={16}>
                              <DGDateTimePicker
                                name="selleravailability"
                                label="Availability"
                                placeholder=''
                                validations={{
                                  isValidDate: true
                                }}
                                validationErrors={{
                                  isValidDate: 'Invalid value'
                                }}
                                onChange={this.onSellerAvailabilityChange}

                              />


                            </Grid.Column>
                            <Grid.Column className='bid-details-bid-price' computer={8} mobile={16}>
                              <DGTextbox
                                autoComplete="off"
                                name="minPrice"
                                placeholder='$00.00'
                                value={this.state.bidPrice}
                                onChange={this.handleChange}
                                label="Bid Price"
                                validations={{

                                  isValidBid: bid.sellerBid
                                }}

                              />
                            </Grid.Column> */}
                          </Grid.Row>

                          {/* <Grid.Row>
                            <Grid.Column width={16} textAlign="center">
                              <Button className="button-request-more-info" onClick={this.onMoreInfoClick}>Request More Info</Button>
                              <Button className="button-submit-green" type="submit">Submit Quote</Button>
                              <button onClick={this.onMoreInfoClick} class="large ui primary button more-info-mobile">
                                Unable to quote a price? Request more info
                              </button>
                            </Grid.Column>
                          </Grid.Row> */}







                        </Grid>
                        {/* <hr className="separator" /> */}
                        {/* <Grid style={{ marginTop: '240px' }}>
                          <Grid.Row>
                            <Grid.Column computer={5} mobile={8} className="content-column">
                              <p>Service</p>
                              <div className="value">{service.name || 'N/A'}</div>
                            </Grid.Column>
                            <Grid.Column computer={5} mobile={8} className="content-column">
                              <p>Lowest Price Quoted</p>
                              <div className="value">{priceDisplay(bid.minBid)}</div>
                            </Grid.Column>
                            <Grid.Column computer={5} mobile={8} className="content-column">
                              <p>Request Expires</p>
                                    <div className="value"><TimeCountDown date={sbr.expiry} /></div>
                              <p>Requested On</p>
                              <div className="value">{moment(sbr.initiated).format('MMM DD, YYYY')}</div>
                            </Grid.Column>
                            <Grid.Column computer={5} mobile={8} className="content-column">
                              <p>Request Info</p>
                              <div className="value">{sbr.quickInfo || null}</div>
                            </Grid.Column>
                            <Grid.Column computer={5} mobile={8} className="content-column">
                              <p>Quote Price:</p>
                              <div className="value">{service.quoteFormat}: Your bid must be for the entire job. Do not bid an hourly rate.</div>
                            </Grid.Column>
                          </Grid.Row>

                        </Grid> */}
                      </div>

                      {/* <div className="place-bid-segment- request-info-container">
                        <RequestInfoNew title="Job Details" serviceRequestInfo={sbr.serviceFormData} />
                      </div> */}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={1} className={"content-container-row"}>
                    {/* {
                      sellerInTrial && window.innerWidth < 1024 && 
                      //this.getFreeTrialMarketingImage(this.state.details.category) &&
                      this.getRightPanelColumn(16)
                    } */}
                    {
                      window.innerWidth <= 1023 && sbr.cellPhone && sellerInTrial && <>
                        <Grid.Column 
                        // onClick={this.handleClick}  
                        width={16}>
                          <div className={"buyer-mobile-container-mobile"}>
                            <div className={"icon-container"}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="21.659" height="21.5" viewBox="0 0 21.659 21.5">
                                <defs>
                                  <clipPath id="clip-path">
                                    <rect id="Rectangle_8721" data-name="Rectangle 8721" width="21.659" height="21.5" fill="#377dff" />
                                  </clipPath>
                                </defs>
                                <g id="Group_15588" data-name="Group 15588" clipPath="url(#clip-path)">
                                  <path id="Path_41833" data-name="Path 41833" d="M4.945.165q.949.943,1.89,1.893.559.56,1.118,1.121a.834.834,0,0,1-.007,1.292c-.683.672-1.37,1.34-2.047,2.018a.483.483,0,0,0-.123.3,6.6,6.6,0,0,0,.675,2.965,10.147,10.147,0,0,0,6.308,5.664,5.552,5.552,0,0,0,1.931.3.5.5,0,0,0,.365-.165c.66-.669,1.326-1.333,1.99-2a.832.832,0,0,1,1.306-.008q1.5,1.5,3,3a.832.832,0,0,1,.121,1.177A13.965,13.965,0,0,1,19.327,20.4a3.567,3.567,0,0,1-1.574.975,8.907,8.907,0,0,1-1.063.128,10.607,10.607,0,0,1-3.819-.912,20.278,20.278,0,0,1-4.757-2.916,26.728,26.728,0,0,1-5.475-5.9A16.317,16.317,0,0,1,.371,7.112,11.571,11.571,0,0,1,.02,5.095,3.509,3.509,0,0,1,1.169,2.107,15.793,15.793,0,0,1,3.875,0" transform="translate(0)" fill="#377dff" />
                                </g>
                              </svg>
                            </div>
                            <div className={"number-container"}>
                              {"Customer Info:"}&nbsp;<span> {sbr.buyerName} </span> &nbsp; <span> {sbr.cellPhone} </span>
                            </div>
                          </div>
                        </Grid.Column>
                        <Grid.Column 
                        // onClick={this.handleClick}
                         >
                          <div className={"submit-btn-container"}>
                            <Button className="button-submit-green" onClick={this.onMoreInfoClick}>Have Questions? Click here</Button>
                          </div>
                        </Grid.Column>
                      </>
                    }
                    <Grid.Column 
                    // onClick={this.handleClick}  
                    computer={(sellerInTrial && window.innerWidth >= 1024) && this.getFreeTrialMarketingImage(this.state.details.category) ? "11" : "16"} mobile={16} tablet={16} style={{ paddingRight: '0px' }}>
                      <Grid.Row columns={1} style={{ paddingTop: "0px" }}>
                        <Grid.Column width="16">
                          <div className="request-info-container">
                            <RequestInfoNew onMoreInfoClick={this.onMoreInfoClick} isUnAuthorized={this.props.isUnAuthorized} title="Customer Provided Details" buyerMobileNo={sbr.cellPhone} buyerName={sbr.buyerName} serviceRequestInfo={sbr.serviceFormData} sellerDetail={seller} />
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns={1}>
                        <Grid.Column width="16">
                          <div className="photos-container">
                            <PhotoCarouselNew images={images} />
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                      {/* <Grid.Row columns={1}>
                        <Grid.Column width={16}>
                          <div className="bid-history-container">
                            <BidHistoryNew bidHistory={bidsHistory} userHas2PlaceBid={bid && !bid.sellerBid} />
                          </div>
                        </Grid.Column>
                      </Grid.Row> */}
                    </Grid.Column>
                    {
                      sellerInTrial && window.innerWidth < 1024 &&
                      //this.getFreeTrialMarketingImage(this.state.details.category) &&
                      this.getRightPanelColumn(16)
                    }
                    {
                      sellerInTrial && window.innerWidth >= 1024
                      && this.getFreeTrialMarketingImage(this.state.details.category) &&
                      this.getRightPanelColumn(5)
                    }
                  </Grid.Row>
                </Grid>
              </Form>
            </Grid.Column>
          </Grid.Row>

          <Modal size='small' open={this.state.isMoreInfoModalOpen} onClose={() => this.setState({ isMoreInfoModalOpen: false })} centered={false} >
            <Modal.Header style={{ fontSize: '14px' }}>Have questions about this request?</Modal.Header>
            <Modal.Content>
              <Formsy onValidSubmit={this.onRequetInfoSubmit}>
                <DGTextarea
                  name='info-request'
                  validationErrors={{
                    isDefaultRequiredValue: 'Please enter some details that you need about this request'
                  }}
                  onChange={(e, data) => this.setState({ sellerInfoRequestMessage: data.value })}
                  required
                  placeholder='Type any information that you need from customer to place a quote'
                  style={{ minHeight: 100, width: '100%', fontSize: '14px', margin: '1rem', minHeight: '100px', padding: '10px', width: 'calc(100% - 2rem)' }} />
                <Grid padded>
                  <Grid.Column width={16} textAlign='right'>
                    <Button primary size='large' >Submit</Button>
                    <Button size='large' onClick={() => this.setState({ isMoreInfoModalOpen: false })}>Close</Button>
                  </Grid.Column>
                </Grid>
              </Formsy>
            </Modal.Content>
          </Modal>
          
          <Modal size='small' 
            open={this.state.isContactDetailsModalOpen} 
            onClose={() => this.setState({ isContactDetailsModalOpen: false })} 
            centered={false} >
            <Modal.Header style={{ fontSize: '18px', fontWeight: '400', textAlign: 'center', lineHeight: '24px' }}>Enter Below. We’ll Call/Email You in 5 Minutes</Modal.Header>
            <Modal.Content>
              <Formsy>
                <Grid padded>

                  <div style={{ marginBottom: '10px', width: '100%' }}>
                    <DGTextbox name="name" label="Name" placeholder="" required type="text"
                      tabIndex={1}
                      maxLength={14}
                      validations={{
                      }}
                      validationErrors={{
                        isDefaultRequiredValue: 'This field is required',
                      }}
                      onChange={(e, { name, value }) => this.setState({ contactName: String(value || '').trim() })}
                      value={this.state.contactName}
                    />
                  </div>

                  <div style={{ marginBottom: '10px', width: '100%' }}>
                    <DGTextbox name="phone" label="Phone Number" placeholder="" required type="text"
                      tabIndex={2}
                      maxLength={14}
                      validations={{
                        isValidCellNumber: true
                      }}
                      validationErrors={{
                        isDefaultRequiredValue: 'This field is required',
                        isValidCellNumber: 'Invalid Cell Number'
                      }}
                      onChange={this.handlePhoneChange}
                      onKeyDown={this.onPhoneKeyDown}
                      value={this.state.phone}
                    />
                  </div>
                  <div style={{ marginBottom: '10px', width: '100%' }}>

                    <DGTextbox name="email" label="Email" placeholder="john@starent.com"
                      required type="text"
                      tabIndex={3}
                      maxLength={100}
                      validations={{
                        isValidEmail: true,
                        maxLength: 100
                      }}
                      validationErrors={{
                        isDefaultRequiredValue: 'This field is required',
                        maxLength: 'Email should not exceed 100 characters.',
                        isEmail: 'Enter a valid email.'
                      }}
                      onChange={(e, { name, value }) => this.setState({ [name]: String(value || '').trim() })}
                      value={this.state.email}
                    />
                  </div>
                </Grid>
                <Grid>
                  {!this.state.isContactDetailsFormValid && <Grid.Column width={16} style={{ fontSize: 16, marginLeft: '15px', color: 'red' }}>
                    Please enter correct details.
                  </Grid.Column>}
                </Grid>
                <Grid padded>
                  <Grid.Column width={16} textAlign='right'>
                    <button tabIndex={4} className='ui large primary button' onClick={this.onContactDetailsSubmit} type='submit' style={{ fontSize: '18px', width: '100%', borderRadius: '14px' }} >Get Customer Details</button>
                  </Grid.Column>
                </Grid>
              </Formsy>
            </Modal.Content>
          </Modal>


          <Modal open={this.state.growWithDealgraceNotificationModal} size="small" onClose={() => this.setState({ growWithDealgraceNotificationModal: false })} className={"grow-with-notification-modal"}>
            <Modal.Content>
              <img src={confirmation_tick}>
              </img>
              <div className="main-msg">
                Stay put.
              </div>
              <div className="sub-msg">
                We’ll reach out shortly.
              </div>
            </Modal.Content>
          </Modal>
        </Grid>
      </div >
    )
  }
}

const mapStateToProps = ({
  auth: { currentUser }
}) => {
  return { currentUser };
}

const mapDispatchToProps = {
  showNotificationMessage,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlaceBidContainerNew));